export const mobile = 800;
export const mobileMinWidth = mobile + 1 + "px";
export const mobileMaxWidth = mobile + "px";

export const colors = {
  primary: "#023047",
  primaryLight: "#034a6e",
  primaryDark: "#011823",

  accent: "#219EBC",
  accentLight: "#8ECAE6",
  accentGradient: "linear-gradient(135deg, #219EBC 0%, #3b6cf6 100%)",

  ink: "#0b1220",
  background: "#f7f8fb",
  surface: "#FFFFFF",
  surfaceMuted: "#eef2f7",

  white: "#FFFFFF",
  offWhite: "#F8F9FA",
  textPrimary: "#0b1220",
  textSecondary: "#5b6474",
  textLight: "#94a3b8",
  textOnDark: "#f8fafc",
  textOnDarkMuted: "#a5b4c8",

  border: "#e4e8ef",
  borderDark: "rgba(255, 255, 255, 0.1)",

  error: "#dc2626",
  success: "#16a34a",

  shadowLight: "0 1px 2px rgba(11, 18, 32, 0.06)",
  shadowMedium: "0 8px 24px -8px rgba(11, 18, 32, 0.16)",
  shadowHeavy: "0 24px 60px -20px rgba(11, 18, 32, 0.28)",
  shadowCard: "0 1px 2px rgba(11, 18, 32, 0.04), 0 8px 32px -12px rgba(11, 18, 32, 0.12)",
};

export const fonts = {
  heading:
    "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
};

export const spacing = {
  sectionY: "120px",
  sectionYMobile: "72px",
  sectionX: "24px",
  maxWidth: "1160px",
};

export const radii = {
  small: "10px",
  medium: "14px",
  large: "24px",
  xl: "32px",
  round: "9999px",
};

export const transitions = {
  default: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
  fast: "all 0.15s ease",
  spring: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
};
